export default __webpack_public_path__ + "static/shells-49ad365db6006f6937525d523f9086d1.jpg";